module.exports = __webpack_public_path__ + "static/homehero-paint-9e2cc7a0183195f8755cf66ad4955ab2.png";